import styled from 'styled-components';
import { COLORS } from '@/constants/styles';
import { getFontStyles } from '@/redux/cmsConfig/utils';

interface StyledInputProps {
  width?: string | number;
}

export const StyledInput = styled.input<StyledInputProps>(({ theme, width }) => ({
  backgroundColor: theme.forms.background_color ?? 'transparent',
  borderRadius: `${theme.forms.border_radius ?? 0}px`,
  border: `1px solid ${theme.forms.border_color ?? 'transparent'}`,
  height: `${theme.forms.field_height}px`,
  padding: '0 var(--size-3)',
  width: width ?? '100%',
  ...getFontStyles(theme.forms.font, ['color', 'font_family', 'font_size']),

  '@media (max-width: 767px)': {
    fontSize: '16px',
    width: '100%',
  },

  '::-webkit-input-placeholder': {
    /* Chrome/Opera/Safari */
    color: theme.forms.placeholder_color,
  },
  '::-moz-placeholder': {
    /* Firefox 19+ */
    color: theme.forms.placeholder_color,
  },
  ':-ms-input-placeholder': {
    /* IE 10+ */
    color: theme.forms.placeholder_color,
  },
  ':-moz-placeholder': {
    /* Firefox 18- */
    color: theme.forms.placeholder_color,
  },

  '&:focus-within': {
    borderColor: theme.global.primary_active_color,
  },
  '&:disabled': {
    background: COLORS.LIGHTGRAY,
    cursor: 'not-allowed',
  },
}));
